import { Image } from './image';
import { Entity } from './entity';
import { environment } from '../../environments/environment';

export class Page extends Entity {

    index: number;
    readSpeakerEnabled: boolean;
    image: Image;
    zoomImage: Image;
    thumbnailImage: Image;
    selections: string;

    getEndpointName(): string {
        return environment.endpointUrls.pages;
    }

}
